import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Camera: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[25px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.34666 3.40077C9.50122 3.15039 9.76141 3 10.04 3H15.04C15.3187 3 15.5789 3.15039 15.7334 3.40077L17.1527 5.7H20.04C20.7031 5.7 21.339 5.98446 21.8078 6.49081C22.2766 6.99716 22.54 7.68391 22.54 8.4V18.3C22.54 19.0161 22.2766 19.7028 21.8078 20.2092C21.339 20.7155 20.7031 21 20.04 21H5.04004C4.377 21 3.74111 20.7155 3.27227 20.2092C2.80343 19.7028 2.54004 19.0161 2.54004 18.3V8.4C2.54004 7.68392 2.80343 6.99716 3.27227 6.49081C3.74111 5.98446 4.377 5.7 5.04004 5.7H7.92739L9.34666 3.40077ZM10.486 4.8L9.06675 7.09923C8.91219 7.34961 8.652 7.5 8.37337 7.5H5.04004C4.81903 7.5 4.60706 7.59482 4.45078 7.7636C4.2945 7.93239 4.20671 8.1613 4.20671 8.4V18.3C4.20671 18.5387 4.2945 18.7676 4.45078 18.9364C4.60706 19.1052 4.81903 19.2 5.04004 19.2H20.04C20.2611 19.2 20.473 19.1052 20.6293 18.9364C20.7856 18.7676 20.8734 18.5387 20.8734 18.3V8.4C20.8734 8.16131 20.7856 7.93239 20.6293 7.7636C20.473 7.59482 20.2611 7.5 20.04 7.5H16.7067C16.4281 7.5 16.1679 7.34961 16.0133 7.09923L14.5941 4.8H10.486Z"
      fill="currentColor"
      strokeWidth="currentStrokWidth"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.54 10.6C11.2146 10.6 10.14 11.6745 10.14 13C10.14 14.3255 11.2146 15.4 12.54 15.4C13.8655 15.4 14.94 14.3255 14.94 13C14.94 11.6745 13.8655 10.6 12.54 10.6ZM8.54004 13C8.54004 10.7909 10.3309 9 12.54 9C14.7492 9 16.54 10.7909 16.54 13C16.54 15.2091 14.7492 17 12.54 17C10.3309 17 8.54004 15.2091 8.54004 13Z"
      fill="currentColor"
      strokeWidth="currentStrokWidth"
    />
  </svg>
);

export default Camera;
